'use client';

import { type ComponentProps } from 'react';
import { Root } from '@radix-ui/react-separator';

import { cn } from '@/util/utils';

function Separator({
    className,
    orientation = 'horizontal',
    decorative = true,
    ref,
    asChild,
    ...props
}: ComponentProps<typeof Root>) {
    return (
        <Root
            data-slot="separator"
            decorative={decorative}
            orientation={orientation}
            ref={ref}
            asChild={asChild}
            className={cn(
                'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
                className,
            )}
            {...props}
        />
    );
}

export { Separator };
